import './IkhlasVerseCard.css';

export function IkhlasVerseCard() {
  const verses = [
    'Say: He is Allah, [who is] One,',
    'Allah, the Eternal Refuge,',
    'He neither begets nor is born,',
    'And there is none comparable to Him.',
  ];

  return (
    <aside className="wi-ikhlas-card" aria-label="Surah Al-Ikhlas">
      <div className="wi-ikhlas-card__verse">
        {verses.map((v, idx) => (
          <p key={idx}>{v}</p>
        ))}
      </div>
      <div className="wi-ikhlas-card__tagline">Islam - The Way to God</div>
    </aside>
  );
}

